// Contexts
import { useProofIncomeContextConsumerHook } from 'containers/proof-income/contexts/proof-income.context';
import { useFetchErrorContextConsumerHook } from 'contexts/fetch-error.context';
// Event Handlers
import { ProofIncomeErrorHandlers } from '../handlers/proof-income-error.handlers';
import { ProofIncomeErrorTrackingHandlers } from '../handlers/proof-income-error.tracking.handlers';
// Hooks
import { useAppTrackingHook } from 'tracking/app-tracking.hook';
// Types
import { ProofIncomeErrorMethodsHandlersType } from '../handlers/types/proof-income-error.handlers.type';

const useProofIncomeErrorHook = (): ProofIncomeErrorMethodsHandlersType => {
  const { setError } = useFetchErrorContextConsumerHook();
  const { setProofIncomeState } = useProofIncomeContextConsumerHook();

  const { handleTrackTryAgain } = useAppTrackingHook(ProofIncomeErrorTrackingHandlers);

  return ProofIncomeErrorHandlers({ handleTrackTryAgain, setError, setProofIncomeState });
};

export { useProofIncomeErrorHook };
